import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { MediaCtaModule } from "@hermes/media-cta";
import { DetectViewportDirectiveModule } from "@hermes/utils-generic/directives/detect-viewport";

import { CHAPTERS_COMPONENT } from "../../core";
import { AnimateOnScrollDirectiveModule } from "../../directives/animate-on-scroll/animate-on-scroll.module";
import { ProductCardModule } from "../product-card/product-card.module";

import { PushMerchAnalyticsService } from "./push-merch-analytics.service";
import { PushMerchComponent } from "./push-merch.component";

@NgModule({
    declarations: [PushMerchComponent],
    imports: [
        CommonModule,
        AnimateOnScrollDirectiveModule,
        MediaCtaModule,
        ProductCardModule,
        DetectViewportDirectiveModule,
    ],
    exports: [PushMerchComponent],
    providers: [
        { provide: CHAPTERS_COMPONENT, useValue: PushMerchComponent },
        PushMerchAnalyticsService,
    ],
})
export class PushMerchModule {}
